/** Traductions écrans de chargement / accès routes (FR / AR) */
export const conditionalRoutesFr = {
  loadingConfig: 'Chargement de la configuration…',
  loadingDashboard: 'Chargement du tableau de bord…',
  loadingApp: 'Chargement de l\'application…',
  accessDenied: 'Accès refusé',
  accessDeniedPage: 'Vous n\'avez pas la permission d\'accéder à cette page.',
  accessDeniedDashboard: 'Vous n\'avez pas la permission d\'accéder au tableau de bord.',
  goBack: 'Retour',
  reloadPage: 'Recharger la page',
  dashboardError: 'Erreur du tableau de bord'
};

export const conditionalRoutesAr = {
  loadingConfig: 'جاري تحميل الإعدادات…',
  loadingDashboard: 'جاري تحميل لوحة التحكم…',
  loadingApp: 'جاري تحميل التطبيق…',
  accessDenied: 'الوصول مرفوض',
  accessDeniedPage: 'ليس لديك صلاحية للوصول إلى هذه الصفحة.',
  accessDeniedDashboard: 'ليس لديك صلاحية للوصول إلى لوحة التحكم.',
  goBack: 'رجوع',
  reloadPage: 'إعادة تحميل الصفحة',
  dashboardError: 'خطأ في لوحة التحكم'
};
